import { NoImage } from 'app/shared/assets';
import React, { useState } from 'react';
import { Loader } from 'app/components/loader';

export const Img = ({ rowView, img, route, lazy, ...rest }) => {
    const [loading, setLoading] = useState(true);
    const src = `${route}${img?.replace('.jpg', '')}`;
    const size = rowView ? 146 : 192;
    return img ? (
        <div
            style={{
                minWidth: loading ? size : 0,
                minHeight: loading ? size : 0,
                height: '100%',
                position: 'relative',
            }}
        >
            {loading ? <Loader /> : null}
            <div
                className={
                    'd-flex align-items-center justify-content-center h-100'
                }
            >
                <img
                    style={{ objectFit: 'contain' }}
                    src={src}
                    loading={lazy ? 'lazy' : 'eager'}
                    width={rowView ? '100%' : undefined}
                    height={'100%'}
                    onLoad={() => setLoading(false)}
                    {...rest}
                />
            </div>
        </div>
    ) : (
        <NoImage />
    );
};
